import React, { useContext, useState, useEffect } from 'react'
import Layout from '../../product/components/templates/Layout'
import CustomTable from '../../product/components/molecules/CustomTable'
import TransactionContext from '../../product/context/transaction/transactionContext'
import CustomSearch from '../../product/components/molecules/CustomSearch'
import { useFormik } from 'formik'

const Transaction = (props) => {
    const transactionContext = useContext(TransactionContext)
    const [isLoading, setIsLoading] = useState(true)
    const {
        all_refund,
        getAllRefund,
        responseStatus: responseStatusInvoice,
        clearResponse: clearResponseInvoice,
    } = transactionContext

    let action = props.match.params.action

    const [tableBody, setTableBody] = useState([])

    const formik = useFormik({
        initialValues: {
            action: action,
            searchterm: '',
            fielddate: 'pr.created_at',
            fromdate: '',
            todate: '',
            page: 1,
            limit: global.initialPageLimit,
            order: '',
            orderby: '',
        },
        onSubmit: (values) => {
            setIsLoading(true)
            getAllRefund(values)
        },
    })

    useEffect(() => {
        if (all_refund) {
            setTableBody(all_refund.records.length ? all_refund.records : [])
        }
        setIsLoading(false)
    }, [all_refund])

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        formik.values.action = action
        formik.values.page = 1
        formik.values.fromdate = ''
        formik.values.todate = ''
        formik.values.searchterm = ''
        getAllRefund(formik.values)
        /* return () => {
            setTableBody([])
        }*/
    }, [action])

    const tableValues = [
        {
            field: 'return_invoice',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Invoice ID',
        },
        {
            field: 'trans_id',
            type: '',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'Transaction ID',
        },
        {
            field: 'amount',
            type: 'price',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Amount',
        },
        {
            field: 'payment_method,mk_card_number,card_type',
            type: 'payment_method',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Card',
        },
        ,
        {
            field: 'first_name,last_name',
            type: '',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'User Name',
        },
        {
            field: 'created_at',
            type: 'date',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Created Date',
        },
        {
            field: 'status',
            type: 'capitalize',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Status',
        },
    ]

    const tableActions = []

    const searchInfo = [
        {
            label: 'Invoice Number',
            placeholder: 'Enter invoice number',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'searchterm',
            formik: formik,
        },
        {
            label: 'Created From Date',
            placeholder: 'Date Ending from',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'date',
            name: 'fromdate',
            formik: formik,
        },
        {
            label: 'Created To Date',
            placeholder: 'Date Ending To',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'date',
            name: 'todate',
            formik: formik,
        },
    ]

    return (
        <Layout>
            <div className="dashboard invoice">
                <CustomSearch searchInfo={searchInfo} formik={formik} />
                <CustomTable
                    formik={formik.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={all_refund}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={getAllRefund}
                />
            </div>
        </Layout>
    )
}

export default Transaction
